import { FormSwitch } from "components/form-fields";
import PropTypes from 'prop-types';
import React from "react";
import 'components/settings/settings.css';

export function MigrationEmployeeBehaviours(
    {
        saving = false,
        onSettingsChange,
        settings
    }
) {

    function onCopyBannedChanged(event) {
        const settingsClone = { ...settings };

        settingsClone.migrateBannedStatus = event.target.checked;

        onSettingsChange(settingsClone);
    } 
 
    return (
        <div>
            <h2>Choose behaviour for migration</h2>
            <FormSwitch
                id="banned-driver-copy"
                disabled={saving}
                headingText="Maintain employee banned status from originating account"
                checked={settings.migrateBannedStatus}
                onChange={onCopyBannedChanged}
            />
            
        </div>
    );
}

MigrationEmployeeBehaviours.propTypes = {
    settings: PropTypes.object.isRequired,
    saving: PropTypes.bool,
    onSettingsChange: PropTypes.func.isRequired
};